// extracted by mini-css-extract-plugin
module.exports = {"background":"PrivacyPolicy_background__2KHQb","privacyContainer":"PrivacyPolicy_privacyContainer__1Pk-P","font":"PrivacyPolicy_font__1eC5k"};